(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-panel"]) return;
  try {
    
  (function () {
    var panel = document.getElementById('contact-panel');
    if (!panel) return;
    var title = panel.querySelector('.side-panel__title');
    var defaultTitle = title ? title.textContent : '';
    var enquiry = panel.querySelector('[data-panel-enquiry]');
    var defaultEnquiry = enquiry ? enquiry.value : '';
    var item = panel.querySelector('[data-panel-item]');
    var input = panel.querySelector('[data-panel-item-input]');

    function reset() {
      if (title) title.textContent = defaultTitle;
      if (enquiry) enquiry.value = defaultEnquiry;
      if (item) item.hidden = true;
      if (input) {
        input.value = '';
        input.disabled = true;
      }
    }

    /* A product card's Enquire now names the painting or piece in the panel and in the email;
       any other way in (the menu's Contact link) opens the general form */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-card-enquire]');
      if (!trigger) {
        var link = event.target.closest('a[href]');
        if (link && link.pathname === panel.getAttribute('data-contact-path')) reset();
        return;
      }
      if (!item || !input) return;
      if (title) title.textContent = trigger.getAttribute('data-enquire-heading') || defaultTitle;
      if (enquiry) enquiry.value = trigger.getAttribute('data-enquire-heading') || defaultEnquiry;
      item.querySelector('[data-panel-item-title]').textContent = trigger.getAttribute('data-enquire-title');
      item.querySelector('[data-panel-item-meta]').textContent = trigger.getAttribute('data-enquire-meta') || '';
      var mount = item.querySelector('.enquiry-summary__image');
      var image = mount.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.className = 'mount__image';
        image.width = 96;
        image.height = 96;
        mount.appendChild(image);
      }
      image.src = trigger.getAttribute('data-enquire-image') || '';
      image.alt = trigger.getAttribute('data-enquire-title') || '';
      item.hidden = false;
      input.value = trigger.getAttribute('data-enquire-item') || '';
      input.disabled = false;
    }, true);

    /* Back to a general contact form once closed */
    panel.addEventListener('close', reset);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Close with a short fade instead of snapping shut. */
    function closeDrawer(drawer, returnFocus) {
      if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
      var finish = function () {
        drawer.classList.remove('is-closing');
        drawer.removeAttribute('open');
        if (returnFocus) drawer.querySelector('summary').focus();
      };
      if (reduceMotion.matches || !document.documentElement.classList.contains('js-motion')) {
        finish();
        return;
      }
      drawer.classList.add('is-closing');
      window.setTimeout(finish, 300);
    }

    document.addEventListener('click', function (event) {
      var summary = event.target.closest('.site-header__toggle');
      if (!summary) return;
      var drawer = summary.parentElement;
      if (drawer.open) {
        event.preventDefault();
        closeDrawer(drawer, false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeDrawer(document.querySelector('.site-header__drawer[open]'), true);
    });

    /*
      Flyouts (e.g. Works): open on hover after a short pause, or on click, tap, Enter or Space; close softly
      when the pointer or focus leaves, on Escape, or on a click elsewhere. Without JS, CSS :hover and
      :focus-within still open them.
    */
    var OPEN_DELAY = 120;
    var CLOSE_DELAY = 250;

    function setOpen(item, open) {
      window.clearTimeout(item._flyoutTimer);
      item.classList.toggle('is-open', open);
      item.querySelector('.site-header__flyout-toggle').setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function later(item, open, delay) {
      window.clearTimeout(item._flyoutTimer);
      item._flyoutTimer = window.setTimeout(function () {
        setOpen(item, open);
      }, delay);
    }

    document.documentElement.classList.add('js-flyout');

    document.querySelectorAll('[data-flyout]').forEach(function (item) {
      var toggle = item.querySelector('.site-header__flyout-toggle');

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse') later(item, true, OPEN_DELAY);
      });
      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'mouse') later(item, false, CLOSE_DELAY);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
      var lastPointer = '';
      toggle.addEventListener('pointerdown', function (event) {
        lastPointer = event.pointerType;
      });
      toggle.addEventListener('click', function (event) {
        /* A mouse click on Works while hovering keeps it open; taps and keys toggle it. */
        if (event.detail > 0 && lastPointer === 'mouse') {
          setOpen(item, true);
          return;
        }
        setOpen(item, !item.classList.contains('is-open'));
      });
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
        setOpen(item, false);
        toggle.focus();
      });
    });

    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-flyout].is-open').forEach(function (item) {
        if (!item.contains(event.target)) setOpen(item, false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Thumbnails crossfade the main view in place. Without JS the first view simply stays visible. */
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      gallery.classList.add('is-enhanced');
      gallery.querySelectorAll('.product__view').forEach(function (view) {
        view.hidden = false;
        view.setAttribute('aria-hidden', view.classList.contains('is-active') ? 'false' : 'true');
        if (!view.classList.contains('is-active')) {
          view.querySelectorAll('a').forEach(function (link) { link.setAttribute('tabindex', '-1'); });
        }
      });
    });

    function showView(thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var targetId = thumb.getAttribute('aria-controls');
      gallery.querySelectorAll('.product__view').forEach(function (view) {
        var active = view.id === targetId;
        view.classList.toggle('is-active', active);
        view.setAttribute('aria-hidden', active ? 'false' : 'true');
        view.querySelectorAll('a').forEach(function (link) {
          if (active) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1');
        });
      });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
        button.setAttribute('aria-pressed', button === thumb ? 'true' : 'false');
      });
    }

    /* Piece options: the price, the page link and the enquiry's Piece field follow the choice. */
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var data = picker.querySelector('[data-variants]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var price = document.querySelector('[data-variant-price]');

      picker.addEventListener('change', function () {
        var chosen = [];
        picker.querySelectorAll('input:checked').forEach(function (input) {
          chosen[Number(input.getAttribute('data-option-position')) - 1] = input.value;
        });
        var match = variants.find(function (item) {
          return item.options.every(function (value, index) { return value === chosen[index]; });
        });
        if (!match) return;

        if (price && price.textContent !== match.price) {
          price.textContent = match.price;
          if (!reduceMotion.matches && price.animate) {
            price.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'cubic-bezier(0.33, 0, 0.2, 1)' });
          }
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState(window.history.state, '', url);

        var field = document.querySelector('[data-enquiry-item]');
        if (field) field.value = [picker.getAttribute('data-product-title'), match.title, match.price].join(', ');
        var summary = document.querySelector('[data-enquiry-summary]');
        if (summary) summary.textContent = match.title + ', ' + match.price;
      });
    });

    /* Lightbox: a modal dialog traps focus natively; Escape and the backdrop close it. */
    var dialog = document.querySelector('[data-lightbox]');
    var image = null;
    if (dialog) {
      image = document.createElement('img');
      image.className = 'lightbox__image';
      image.alt = '';
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-pressed', 'false');
      dialog.querySelector('[data-lightbox-stage]').appendChild(image);
    }

    function toggleZoom(originX, originY) {
      image.style.transformOrigin = originX * 100 + '% ' + originY * 100 + '%';
      var zoomed = dialog.classList.toggle('is-zoomed');
      image.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    }
    var opener = null;

    function openLightbox(link) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      opener = link;
      image.src = link.getAttribute('href');
      image.alt = link.getAttribute('data-zoom-alt') || '';
      image.setAttribute('aria-pressed', 'false');
      dialog.classList.remove('is-closing', 'is-zoomed');
      dialog.showModal();
      return true;
    }

    function closeLightbox() {
      if (!dialog || !dialog.open) return;
      var finish = function () {
        dialog.classList.remove('is-closing', 'is-zoomed');
        dialog.close();
        if (opener) opener.focus();
      };
      if (reduceMotion.matches) {
        finish();
        return;
      }
      dialog.classList.add('is-closing');
      window.setTimeout(finish, 450);
    }

    if (dialog) {
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeLightbox();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('[data-lightbox-close]')) {
          closeLightbox();
          return;
        }
        if (event.target === image) {
          var rect = image.getBoundingClientRect();
          toggleZoom((event.clientX - rect.left) / rect.width, (event.clientY - rect.top) / rect.height);
        }
      });
      dialog.addEventListener('keydown', function (event) {
        if (event.target === image && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          toggleZoom(0.5, 0.5);
          return;
        }
        if (event.key !== 'Tab') return;
        var focusables = [dialog.querySelector('[data-lightbox-close]'), image];
        var index = focusables.indexOf(document.activeElement);
        var next = event.shiftKey ? index - 1 : index + 1;
        if (next < 0) next = focusables.length - 1;
        if (next >= focusables.length) next = 0;
        event.preventDefault();
        focusables[next].focus();
      });
      dialog.addEventListener('pointermove', function (event) {
        if (!dialog.classList.contains('is-zoomed') || event.pointerType === 'touch') return;
        var rect = image.getBoundingClientRect();
        var x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        var y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);
        image.style.transformOrigin = x * 100 + '% ' + y * 100 + '%';
      });
    }

    document.addEventListener('click', function (event) {
      var zoom = event.target.closest('[data-zoom]');
      if (zoom) {
        if (openLightbox(zoom)) event.preventDefault();
        return;
      }

      var thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        showView(thumb);
        return;
      }

      var enquire = event.target.closest('[data-enquire]');
    if (!enquire) return;
    var form = document.getElementById('ProductEnquiry');
    if (!form) return;
    var message = form.querySelector('textarea[name="contact[body]"]');
    var typeField = form.querySelector('input[name="contact[Enquiry]"]');
    if (typeField && enquire.getAttribute('data-enquiry-type')) {
      typeField.value = enquire.getAttribute('data-enquiry-type');
    }
    var reserveText = enquire.getAttribute('data-reserve');
    if (message && reserveText && message.value.trim() === '') {
      message.value = reserveText;
    }
    var name = form.querySelector('input[name="contact[name]"]');
    if (name) {
      window.setTimeout(function () {
        name.focus({ preventScroll: true });
      }, 0);
    }
    });

    /* Keep the details column in view while the images scroll, but only when it fits on screen. */
    var info = document.querySelector('.product__info');
    if (info) {
      var fitSticky = function () {
        var header = document.querySelector('.shopify-section-group-header-group');
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        info.classList.toggle('is-sticky', info.offsetHeight + headerHeight + 48 < window.innerHeight);
      };
      fitSticky();
      window.addEventListener('resize', fitSticky);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
